var core = module.exports = {version: '1.2.6'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// /~/core-js/library/modules/$.core.js
// module id = 145
// module chunks = 0